export const Performance = () => (
  <span role="img" aria-label="performance" className="anticon  ant-menu-item-icon">
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 20V4" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round" />
      <path d="M3 20H21" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round" />
      <path
        d="M3.72229 19.5L5.77786 19.0195C7.23032 18.6799 8.55892 17.9411 9.61365 16.8863L9.80361 16.6964C10.2661 16.2339 10.6702 15.7164 11.0067 15.1555L11.6702 14.0497C11.8897 13.6838 12.0796 13.301 12.2381 12.9048L13 11L13.6175 9.14737C13.8666 8.40026 14.3375 7.74686 14.9675 7.27434V7.27434C15.6377 6.77171 16.4528 6.5 17.2906 6.5H20.5"
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);
